// extracted by mini-css-extract-plugin
export const languageSelector = "LanguageSelector-module--language-selector--5hzlc";
export const button = "LanguageSelector-module--button--gNJM2";
export const contentWrapper = "LanguageSelector-module--content-wrapper--1lWnq";
export const content = "LanguageSelector-module--content--2vUAq";
export const languageList = "LanguageSelector-module--language-list--2hZ1h";